import {forwardRef, memo, useCallback, useImperativeHandle, useMemo, useState} from 'react';
import styles from './index.module.scss';
import Dialog from '@/components/Dialog';
import TemplatePreview from './TemplatePreview';
import {DialogCloseSvg} from '@/icons';
import {IconSize} from '@/components/Icon';
import {Template} from '@/interface';
import TemplateCard from '../TemplateCard';
import classNames from 'classnames';

interface TemplateCenterProps {
    sysTpls: Template[];
    userTpls: Template[];
    openPreview: (templateItem: Template) => void;
    onUseTemplate: (template: Template) => any;
}
function TemplateCenter({
    sysTpls,
    userTpls,
    openPreview,
    onUseTemplate,
}: TemplateCenterProps) {

    const templateList = useMemo(() => ([
        {
            title: '自定义',
            dataList: userTpls,
        },
        {
            title: '推荐模版',
            dataList: sysTpls,
        },
    ]), [sysTpls, userTpls]);

    const handleClickCard = useCallback((templateItem: Template) => {
        return (e: any) => {
            openPreview(templateItem);
            e.stopPropagation();
        };
    }, [openPreview]);

    return <div className={styles.centerWrap}>
        <div className={styles.head}>
            <span>选择模版</span>
        </div>
        <div className={styles.contanier}>
            {
                templateList.map(item => {
                    if (!item.dataList.length) {
                        return <></>;
                    }
                    return <div key={item.title} className={styles.typeModule}>
                        <p className={styles.title} key={item.title}>{item.title}</p>
                        <div className={styles.listWrap}>
                            {
                                item.dataList.map(data => {
                                    return <TemplateCard
                                        key={data.id}
                                        className={styles.modalCard}
                                        data={data}
                                        openPreview={openPreview}
                                        onUseTemplate={onUseTemplate}
                                        onClickCard={handleClickCard}
                                        imgBox={{width: 186, height: 46}}
                                    />;
                                })
                            }
                        </div>
                    </div>;
                })
            }
        </div>
    </div>;
}

interface TemplateModalProps {
    sysTpls: Template[];
    userTpls: Template[];
    visible: boolean;
    onUseTemplate: (template: Template) => any;
    onVisibleChange: (visible: boolean) => void;
}

export enum TemplateLevel {
    first = 1,
    second = 2,
}

const TemplateModal = forwardRef(({
    sysTpls,
    userTpls,
    visible,
    onUseTemplate,
    onVisibleChange,
}: TemplateModalProps, ref) => {
    const [level, setLevel] = useState(TemplateLevel.first);
    const [curTemplate, setCurTemplate] = useState<Template | null>(null);


    function handleBack() {
        setLevel(TemplateLevel.first);
    }

    function handleClose() {
        onVisibleChange && onVisibleChange(false);
        if (level !== TemplateLevel.first) {
            handleBack();
        }
    }

    const handleGoPreview = useCallback((tempalteItem: Template) => {
        setLevel(TemplateLevel.second);
        setCurTemplate(tempalteItem);
    }, []);

    useImperativeHandle(ref, () => {
        return {
            handleGoPreview,
        };
    });

    return <Dialog
        className={classNames(
            styles.modal,
            level === TemplateLevel.first && styles.modalListWrap
        )}
        visible={visible}
        maxHeight={720}
        onCancel={handleClose}
        showCloseX
    >
        {
            level === TemplateLevel.first
            && <TemplateCenter
                sysTpls={sysTpls}
                userTpls={userTpls}
                openPreview={handleGoPreview}
                onUseTemplate={onUseTemplate}
            />
        }
        {
            level === TemplateLevel.second
            && curTemplate
            && <TemplatePreview
                onBack={handleBack}
                curTemplate={curTemplate}
                onUseTemplate={onUseTemplate}
            />
        }
    </Dialog>;
});

export default memo(TemplateModal);
